import api from "../../../api.js";

// Fetch patients with clinic scripts only
export async function fetchPatientsWithClinicScripts(searchTerm = "") {
  const res = await api.get("/api/clinic/patients-with-clinic-scripts", { params: { search: searchTerm } });
  return res.data?.data || [];
}

// Fetch clinic scripts for a specific patient
export async function fetchPatientClinicScripts(patientId, branchcode) {
  try {
    const params = {};
    if (branchcode) params.branchcode = branchcode;
    const res = await api.get(`/api/clinic/patients/${encodeURIComponent(patientId)}/scripts`, { params });
    return res.data?.data || [];
  } catch (error) {
    throw error;
  }
}

// Fetch clinic script details - using same endpoint as process scripts but filter by type
export async function fetchClinicScriptDetails(scriptId) {
  try {
    const res = await api.get(`/api/clinic/scripts/${encodeURIComponent(scriptId)}/details`);
    
    // Filter to ensure it's a clinic script
    const data = res.data?.data;
    if (data && data.script && data.script.type === 'clinic') {
      return data;
    }
    
    return null;
  } catch (error) {
    throw error;
  }
}

// Create a new clinic script
export async function createClinicScript(payload) {
  const res = await api.post("/scripts", payload);
  return res.data?.data;
}

// Update clinic script
export async function updateClinicScript(scriptId, payload) {
  const res = await api.put(`/scripts/${encodeURIComponent(scriptId)}`, payload);
  return res.data?.data;
}

// Delete clinic script
export async function deleteClinicScript(scriptId) {
  const res = await api.delete(`/scripts/${encodeURIComponent(scriptId)}`);
  return res.data?.data;
}

// Fetch clinic script follow-up
export async function fetchClinicScriptFollowUp(scriptId) {
  const res = await api.get(`/scripts/${encodeURIComponent(scriptId)}/followup`);
  return res.data?.data || null;
}

// Save clinic script follow-up
export async function saveClinicScriptFollowUp(scriptId, payload) {
  const res = await api.post(`/scripts/${encodeURIComponent(scriptId)}/followup`, payload);
  return res.data?.data;
}

// Fetch clinic script medication history
export async function fetchClinicScriptMedicationHistory(patientId) {
  const res = await api.get(`/patients/${encodeURIComponent(patientId)}/scripts/history`);
  const allHistory = res.data?.data || [];
  
  // Filter only clinic scripts
  const clinicHistory = allHistory.filter(item => item.type === 'clinic');
  
  return clinicHistory;
}

// Fetch clinic script customer details
export async function fetchClinicScriptCustomerDetails(customerId) {
  const res = await api.get(`/customers/${encodeURIComponent(customerId)}/details`);
  return res.data?.data;
}

// Fetch clinic script patient details
export async function fetchClinicScriptPatientDetails(patientId) {
  const res = await api.get(`/patients/${encodeURIComponent(patientId)}/details`);
  return res.data?.data;
}
